import React, { useState, useEffect } from "react";
import { BiChevronUpCircle } from "react-icons/bi";
import "./scrollToTopButton.scss";

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowButton(window.scrollY > 0);

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div
      className={`up-button ${showButton ? "visible" : "hidden"}`}
      onClick={scrollToTop}
    >
      <BiChevronUpCircle />
    </div>
  );
};

export default ScrollToTopButton;
